import ProjectStore from "./ProjectStore"

export default class RootStore {
    projectStore: ProjectStore = new ProjectStore();
}